import "./ScalabilityScroll.css";

const technologyCards = [
  {
    border: "4px solid #FF6C6C",
    id: 1,
    title: "Advanced ML Frameworks",
    description:
      "We work with modern machine learning frameworks that support deep learning, neural networks, and classical models—helping us build accurate, scalable, and production-ready solutions tailored to your business challenges.",
  },
  {
    border: "4px solid #37A802",
    id: 2,
    title: "Data Processing & Feature Engineering Tools",
    description:
      "Our team uses powerful data preprocessing and transformation tools to clean, enrich, and structure raw datasets. This ensures the ML models learn from meaningful patterns and deliver sharper predictions.",
  },
  {
    border: "4px solid #26DAB6",
    id: 3,
    title: "Model Training & Optimization Platforms",
    description:
      "We rely on technology that accelerates model training, hyperparameter tuning, and performance evaluation. This helps us deliver high-accuracy models faster, with consistent results across different environments.",
  },
  {
    border: "4px solid #3756D4",
    id: 4,
    title: "Cloud-Based ML Deployment Systems",
    description:
      "Our ML solutions are deployed on secure cloud platforms that support autoscaling, load balancing, and real-time performance. This ensures stable and reliable operations, even during heavy workloads.",
  },
  {
    border: "4px solid #6E2FBC",
    id: 5,
    title: "Workflow Automation & MLOps Pipelines",
    description:
      "We use automated pipelines for versioning, monitoring, and lifecycle management. This keeps your machine learning models updated, optimized, and fully aligned with changing business needs.",
  },
  {
    border: "4px solid #E31BA0",
    id: 6,
    title: "Real-Time API & Integration Layer",
    description:
      "Our ML models are integrated through fast, secure API layers that support real-time predictions and seamless connectivity with your existing software, dashboards, or enterprise systems.",
  },
];

export default function ScalabilityScroll() {
  return (
    <div id="scalability-scroll" className="machinemainclass">
      <div className="left">
        <h2 className="heading">
          Tools, Libraries & Frameworks Behind Our ML Expertise
        </h2>
        <p className="subheading">
          As a machine learning development company trusted by enterprises, we
          use a powerful mix of tools, libraries, and frameworks to build
          accurate, scalable, and production-ready models. Our tech stack
          ensures faster experimentation, smoother deployment, and consistently
          reliable performance in real-world environments.
        </p>
      </div>

      <div className="right">
        <div className="cards">
          {technologyCards.map((card) => (
            <div
              className="card"
              key={card.id}
              style={{ borderLeft: card.border }}
            >
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
